export function getConfig() {
    var config = {};
    config.token = Office.context.roamingSettings.get('token');
    return config;
}

export function setConfig(config, callback) {
    Office.context.roamingSettings.set('token', config.token);
    Office.context.roamingSettings.saveAsync(callback);
}